import { ReactNode, useEffect, useState, useMemo } from 'react';

// third-party
import { IntlProvider, MessageFormatElement } from 'react-intl';

// project imports
import useConfig from 'hooks/useConfig';
import { I18n } from 'types/config';

// load locales files
const loadLocaleData = (locale: I18n) => {
  switch (locale) {
  case 'en':
      return import('utils/locales/en.json');
    case 'hu':
    default:
      return import('utils/locales/hu.json');
  }
};

interface Props {
  children: ReactNode;
}

// ==============================|| LOCALIZATION ||============================== //

export default function Locales({ children }: Props) {
  const { i18n } = useConfig();

  const [messages, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>();
  const localeDataPromise = useMemo(() => loadLocaleData(i18n), [i18n]);

  useEffect(() => {
    localeDataPromise.then((d: { default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined }) => {
      setMessages(d.default);
    });
  }, [localeDataPromise]);

  return (
    <>
      {messages && (
        <IntlProvider locale={i18n} defaultLocale="en" messages={messages}>
          {children}
        </IntlProvider>
      )}
    </>
  );
}
